import { useCallback } from 'react';
import { NavigateOptions, useNavigate } from 'react-router';

const useNavigateInPurchase = () => {
  const navigate = useNavigate();

  const navigateInPurchase = useCallback(
    (path: string, opts?: NavigateOptions) => {
      navigate(path, opts);
    },
    [navigate]
  );

  return navigateInPurchase;
};

export default useNavigateInPurchase;
